import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class LightCavalryBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.LIGHT_CAVALRY;
}

export default LightCavalryBuildingTileEntity;
